/**
 * Normalize a contact-local timezone string into a valid IANA identifier.
 *
 * Blank and invalid values collapse to `null` so runtime callers can treat
 * missing timezone data as "no deferral needed".
 *
 * @param {unknown} value - Candidate timezone string.
 * @returns {string|null} Valid IANA timezone or `null` when unavailable.
 */
export function normalizeContactTimeZone(value) {
  const candidate = String(value || '').trim();
  if (!candidate) return null;
  try {
    new Intl.DateTimeFormat('en-US', { timeZone: candidate }).format(
      new Date()
    );
    return candidate;
  } catch {
    return null;
  }
}
